(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commercial-real-estate-partner-program"] && !Shopify.designMode) return;
  try {
    
  const sendCommercialPartnerProgramEvent = (root, eventName, parameters = {}) => {
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const eventParameters = {
      landing_page_id: root.dataset.ga4PageId,
      page_market: 'san_diego',
      ...parameters
    };
    const measurementId = root.dataset.ga4MeasurementId.trim();
    if (measurementId) eventParameters.send_to = measurementId;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventParameters });
  };

  const initCommercialPartnerProgramAnalytics = (root) => {
    if (root.dataset.ga4Initialized === 'true') return;
    root.dataset.ga4Initialized = 'true';
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ga4-event]');
      if (!trigger || !root.contains(trigger)) return;
      const parameters = {
        element_id: trigger.dataset.ga4Id,
        placement: trigger.dataset.ga4Location
      };
      if (trigger.dataset.ga4DestinationType) {
        parameters.destination_type = trigger.dataset.ga4DestinationType;
      }
      if (trigger.dataset.ga4Event === 'contact_click') {
        parameters.contact_method = trigger.dataset.ga4Id;
      }
      sendCommercialPartnerProgramEvent(root, trigger.dataset.ga4Event, parameters);
    });

    if ('IntersectionObserver' in window) {
      const impressionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.dataset.ga4Viewed === 'true') return;
            entry.target.dataset.ga4Viewed = 'true';
            if (entry.target.hasAttribute('data-ga4-form-view')) {
              sendCommercialPartnerProgramEvent(root, 'lead_form_view', {
                form_id: 'commercial_real_estate_partner_program_intro'
              });
            } else {
              sendCommercialPartnerProgramEvent(root, 'section_view', {
                section_name: entry.target.dataset.ga4Section
              });
            }
            impressionObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
      );
      root.querySelectorAll('[data-ga4-section], [data-ga4-form-view]').forEach((element) => {
        impressionObserver.observe(element);
      });
    }

    const form = root.querySelector('.crpp-form');
    const leadPendingKey = 'commercial_partner_program_lead_pending_at';
    const leadSentKey = 'commercial_partner_program_generate_lead_sent';
    const leadPendingTtl = 30 * 60 * 1000;
    if (form) {
      const returnToInput = form.querySelector('input[name="return_to"]');
      const currentPageUrl = new URL(window.location.href);
      if (
        returnToInput &&
        currentPageUrl.hostname.endsWith('.shopifypreview.com') &&
        currentPageUrl.searchParams.has('preview_key')
      ) {
        const contactSection = root.querySelector('.crpp-contact');
        currentPageUrl.searchParams.set('commercial_partner_program_posted', 'true');
        returnToInput.value = `${currentPageUrl.pathname}${currentPageUrl.search}${
          contactSection && contactSection.id ? `#${contactSection.id}` : ''
        }`;
      }

      let lastInvalidEventAt = 0;
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-ga4-role]') && event.target.value) {
          const selectedOption = event.target.selectedOptions[0];
          sendCommercialPartnerProgramEvent(root, 'lead_form_option', {
            form_id: 'commercial_real_estate_partner_program_intro',
            option_type: 'professional_role',
            option_id: selectedOption.dataset.ga4OptionId
          });
        }
      });

      form.addEventListener(
        'invalid',
        () => {
          const now = Date.now();
          if (now - lastInvalidEventAt < 750) return;
          lastInvalidEventAt = now;
          sendCommercialPartnerProgramEvent(root, 'lead_form_error', {
            form_id: 'commercial_real_estate_partner_program_intro',
            error_type: 'client_validation'
          });
        },
        true
      );

      form.addEventListener('submit', () => {
        try {
          window.sessionStorage.setItem(leadPendingKey, String(Date.now()));
          window.sessionStorage.removeItem(leadSentKey);
        } catch (error) {
          return;
        }
      });
    }

    const successMessage = root.querySelector('[data-ga4-lead-success]');
    const errorMessage = root.querySelector('[data-ga4-form-error]');
    if (successMessage || errorMessage) {
      let pendingSubmission = false;
      let leadAlreadySent = true;
      try {
        const pendingAt = Number(window.sessionStorage.getItem(leadPendingKey));
        pendingSubmission = Number.isFinite(pendingAt) && pendingAt > 0 && Date.now() - pendingAt <= leadPendingTtl;
        window.sessionStorage.removeItem(leadPendingKey);
        leadAlreadySent = window.sessionStorage.getItem(leadSentKey) === 'true';
      } catch (error) {
        pendingSubmission = false;
      }

      const resultUrl = new URL(window.location.href);
      const hasReturnMarker = resultUrl.searchParams.get('commercial_partner_program_posted') === 'true';
      const verifiedOutcome = pendingSubmission && hasReturnMarker;

      if (successMessage && verifiedOutcome && !leadAlreadySent) {
        sendCommercialPartnerProgramEvent(root, 'generate_lead', {
          form_id: 'commercial_real_estate_partner_program_intro',
          lead_source: 'commercial_real_estate_partner_program'
        });
        try {
          window.sessionStorage.setItem(leadSentKey, 'true');
        } catch (error) {
          leadAlreadySent = true;
        }
      }
      if (errorMessage && verifiedOutcome) {
        sendCommercialPartnerProgramEvent(root, 'lead_form_error', {
          form_id: 'commercial_real_estate_partner_program_intro',
          error_type: 'server_validation'
        });
      }
      if (successMessage) successMessage.focus();

      if (hasReturnMarker) {
        resultUrl.searchParams.delete('commercial_partner_program_posted');
        window.history.replaceState(
          window.history.state,
          '',
          `${resultUrl.pathname}${resultUrl.search}${resultUrl.hash}`
        );
      }
    }

    const scrollMilestones = [25, 50, 75];
    const sentMilestones = new Set();
    let scrollFramePending = false;
    const measureScroll = () => {
      scrollFramePending = false;
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;
      const percentScrolled = Math.round((window.scrollY / scrollableHeight) * 100);
      scrollMilestones.forEach((milestone) => {
        if (percentScrolled >= milestone && !sentMilestones.has(milestone)) {
          sentMilestones.add(milestone);
          sendCommercialPartnerProgramEvent(root, 'scroll_depth', {
            percent_scrolled: milestone
          });
        }
      });
    };
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFramePending) return;
        scrollFramePending = true;
        window.requestAnimationFrame(measureScroll);
      },
      { passive: true }
    );
    measureScroll();
  };

  const initCommercialPartnerProgram = (root) => {
    document.documentElement.classList.add('crpp-motion-ready');
    const reveals = root.querySelectorAll('.crpp-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      reveals.forEach((element) => observer.observe(element));
    }
    initCommercialPartnerProgramAnalytics(root);
  };

  document.querySelectorAll('.crpp-page').forEach(initCommercialPartnerProgram);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.crpp-page');
    if (root) initCommercialPartnerProgram(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["commercial-realtors"] && !Shopify.designMode) return;
  try {
    
  const sendCommercialReEvent = (root, eventName, parameters = {}) => {
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const eventParameters = {
      landing_page_id: root.dataset.ga4PageId,
      page_market: 'san_diego',
      ...parameters
    };
    const measurementId = root.dataset.ga4MeasurementId.trim();
    if (measurementId) eventParameters.send_to = measurementId;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventParameters });
  };

  const initCommercialReAnalytics = (root) => {
    if (root.dataset.ga4Initialized === 'true') return;
    root.dataset.ga4Initialized = 'true';
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ga4-event]');
      if (!trigger || !root.contains(trigger)) return;
      const parameters = {
        element_id: trigger.dataset.ga4Id,
        placement: trigger.dataset.ga4Location
      };
      if (trigger.dataset.ga4DestinationType) {
        parameters.destination_type = trigger.dataset.ga4DestinationType;
      }
      if (trigger.dataset.ga4ContentType) {
        parameters.content_type = trigger.dataset.ga4ContentType;
        parameters.content_id = `service_${trigger.dataset.ga4Id}`;
      }
      if (trigger.dataset.ga4Event === 'contact_click') {
        parameters.contact_method = trigger.dataset.ga4Id;
      }
      sendCommercialReEvent(root, trigger.dataset.ga4Event, parameters);
    });

    if ('IntersectionObserver' in window) {
      const impressionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.dataset.ga4Viewed === 'true') return;
            entry.target.dataset.ga4Viewed = 'true';
            if (entry.target.hasAttribute('data-ga4-form-view')) {
              sendCommercialReEvent(root, 'lead_form_view', {
                form_id: 'commercial_real_estate_quote'
              });
            } else {
              sendCommercialReEvent(root, 'section_view', {
                section_name: entry.target.dataset.ga4Section
              });
            }
            impressionObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
      );
      root.querySelectorAll('[data-ga4-section], [data-ga4-form-view]').forEach((element) => {
        impressionObserver.observe(element);
      });
    }

    const form = root.querySelector('.cr-form');
    const leadPendingKey = 'commercial_re_lead_pending_at';
    const leadSentKey = 'commercial_re_generate_lead_sent';
    const leadPendingTtl = 30 * 60 * 1000;
    if (form) {
      const returnToInput = form.querySelector('input[name="return_to"]');
      const currentPageUrl = new URL(window.location.href);
      if (
        returnToInput &&
        currentPageUrl.hostname.endsWith('.shopifypreview.com') &&
        currentPageUrl.searchParams.has('preview_key')
      ) {
        const contactSection = root.querySelector('.cr-contact');
        currentPageUrl.searchParams.set('contact_posted', 'true');
        returnToInput.value = `${currentPageUrl.pathname}${currentPageUrl.search}${
          contactSection && contactSection.id ? `#${contactSection.id}` : ''
        }`;
      }

      let lastInvalidEventAt = 0;
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-ga4-project-type]') && event.target.value) {
          const selectedOption = event.target.selectedOptions[0];
          sendCommercialReEvent(root, 'lead_form_option', {
            form_id: 'commercial_real_estate_quote',
            option_type: 'project_type',
            option_id: selectedOption.dataset.ga4OptionId
          });
        }
        if (event.target.matches('[data-ga4-material-id]') && event.target.checked) {
          sendCommercialReEvent(root, 'lead_form_option', {
            form_id: 'commercial_real_estate_quote',
            option_type: 'material',
            option_id: event.target.dataset.ga4MaterialId
          });
        }
      });

      form.addEventListener(
        'invalid',
        () => {
          const now = Date.now();
          if (now - lastInvalidEventAt < 750) return;
          lastInvalidEventAt = now;
          sendCommercialReEvent(root, 'lead_form_error', {
            form_id: 'commercial_real_estate_quote',
            error_type: 'client_validation'
          });
        },
        true
      );

      form.addEventListener('submit', () => {
        try {
          window.sessionStorage.setItem(leadPendingKey, String(Date.now()));
          window.sessionStorage.removeItem(leadSentKey);
        } catch (error) {
          return;
        }
      });
    }

    const successMessage = root.querySelector('[data-ga4-lead-success]');
    const errorMessage = root.querySelector('[data-ga4-form-error]');
    if (successMessage || errorMessage) {
      let pendingSubmission = null;
      let leadAlreadySent = false;
      try {
        const pendingAt = Number(window.sessionStorage.getItem(leadPendingKey));
        pendingSubmission = Number.isFinite(pendingAt) && pendingAt > 0 && Date.now() - pendingAt <= leadPendingTtl;
        window.sessionStorage.removeItem(leadPendingKey);
        leadAlreadySent = window.sessionStorage.getItem(leadSentKey) === 'true';
      } catch (error) {
        pendingSubmission = null;
      }

      const resultUrl = new URL(window.location.href);
      const hasReturnMarker = resultUrl.searchParams.get('contact_posted') === 'true';
      const verifiedOutcome = pendingSubmission === true || (pendingSubmission === null && hasReturnMarker);

      if (successMessage && verifiedOutcome && !leadAlreadySent) {
        sendCommercialReEvent(root, 'generate_lead', {
          form_id: 'commercial_real_estate_quote',
          lead_source: 'website_form'
        });
        try {
          window.sessionStorage.setItem(leadSentKey, 'true');
        } catch (error) {
          leadAlreadySent = true;
        }
      }
      if (errorMessage && verifiedOutcome) {
        sendCommercialReEvent(root, 'lead_form_error', {
          form_id: 'commercial_real_estate_quote',
          error_type: 'server_validation'
        });
      }
      if (successMessage) successMessage.focus();

      if (hasReturnMarker) {
        resultUrl.searchParams.delete('contact_posted');
        window.history.replaceState(
          window.history.state,
          '',
          `${resultUrl.pathname}${resultUrl.search}${resultUrl.hash}`
        );
      }
    }

    const scrollMilestones = [25, 50, 75];
    const sentMilestones = new Set();
    let scrollFramePending = false;
    const measureScroll = () => {
      scrollFramePending = false;
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;
      const percentScrolled = Math.round((window.scrollY / scrollableHeight) * 100);
      scrollMilestones.forEach((milestone) => {
        if (percentScrolled >= milestone && !sentMilestones.has(milestone)) {
          sentMilestones.add(milestone);
          sendCommercialReEvent(root, 'scroll_depth', {
            percent_scrolled: milestone
          });
        }
      });
    };
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFramePending) return;
        scrollFramePending = true;
        window.requestAnimationFrame(measureScroll);
      },
      { passive: true }
    );
    measureScroll();
  };

  const initCommercialRealtors = (root) => {
    document.documentElement.classList.add('cr-motion-ready');
    const reveals = root.querySelectorAll('.cr-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      reveals.forEach((element) => observer.observe(element));
    }
    initCommercialReAnalytics(root);
  };

  document.querySelectorAll('.cr-page').forEach(initCommercialRealtors);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.cr-page');
    if (root) initCommercialRealtors(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["property-management"] && !Shopify.designMode) return;
  try {
    
  const sendPropertyManagementEvent = (root, eventName, parameters = {}) => {
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    const eventParameters = {
      landing_page_id: root.dataset.ga4PageId,
      page_market: 'san_diego',
      ...parameters
    };
    const measurementId = root.dataset.ga4MeasurementId.trim();
    if (measurementId) eventParameters.send_to = measurementId;

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParameters);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventParameters });
  };

  const initPropertyManagementAnalytics = (root) => {
    if (root.dataset.ga4Initialized === 'true') return;
    root.dataset.ga4Initialized = 'true';
    if (root.dataset.ga4Enabled !== 'true') return;
    if (window.Shopify && window.Shopify.designMode) return;

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ga4-event]');
      if (!trigger || !root.contains(trigger)) return;
      const parameters = {
        element_id: trigger.dataset.ga4Id,
        placement: trigger.dataset.ga4Location
      };
      if (trigger.dataset.ga4DestinationType) {
        parameters.destination_type = trigger.dataset.ga4DestinationType;
      }
      if (trigger.dataset.ga4ContentType) {
        parameters.content_type = trigger.dataset.ga4ContentType;
        parameters.content_id = `pm_service_${trigger.dataset.ga4Id}`;
      }
      if (trigger.dataset.ga4Event === 'contact_click') {
        parameters.contact_method = trigger.dataset.ga4Id;
      }
      sendPropertyManagementEvent(root, trigger.dataset.ga4Event, parameters);
    });

    if ('IntersectionObserver' in window) {
      const impressionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.target.dataset.ga4Viewed === 'true') return;
            entry.target.dataset.ga4Viewed = 'true';
            if (entry.target.hasAttribute('data-ga4-form-view')) {
              sendPropertyManagementEvent(root, 'lead_form_view', {
                form_id: 'property_management_print_quote'
              });
            } else {
              sendPropertyManagementEvent(root, 'section_view', {
                section_name: entry.target.dataset.ga4Section
              });
            }
            impressionObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px', threshold: 0.15 }
      );
      root.querySelectorAll('[data-ga4-section], [data-ga4-form-view]').forEach((element) => {
        impressionObserver.observe(element);
      });
    }

    const form = root.querySelector('.pm-form');
    const leadPendingKey = 'property_management_lead_pending_at';
    const leadSentKey = 'property_management_generate_lead_sent';
    const leadPendingTtl = 30 * 60 * 1000;
    if (form) {
      const returnToInput = form.querySelector('input[name="return_to"]');
      const currentPageUrl = new URL(window.location.href);
      if (
        returnToInput &&
        currentPageUrl.hostname.endsWith('.shopifypreview.com') &&
        currentPageUrl.searchParams.has('preview_key')
      ) {
        const contactSection = root.querySelector('.pm-contact');
        currentPageUrl.searchParams.set('property_management_posted', 'true');
        returnToInput.value = `${currentPageUrl.pathname}${currentPageUrl.search}${
          contactSection && contactSection.id ? `#${contactSection.id}` : ''
        }`;
      }

      let lastInvalidEventAt = 0;
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-ga4-project-type]') && event.target.value) {
          const selectedOption = event.target.selectedOptions[0];
          sendPropertyManagementEvent(root, 'lead_form_option', {
            form_id: 'property_management_print_quote',
            option_type: 'project_type',
            option_id: selectedOption.dataset.ga4OptionId
          });
        }
        if (event.target.matches('[data-ga4-material-id]') && event.target.checked) {
          sendPropertyManagementEvent(root, 'lead_form_option', {
            form_id: 'property_management_print_quote',
            option_type: 'material',
            option_id: event.target.dataset.ga4MaterialId
          });
        }
      });

      form.addEventListener(
        'invalid',
        () => {
          const now = Date.now();
          if (now - lastInvalidEventAt < 750) return;
          lastInvalidEventAt = now;
          sendPropertyManagementEvent(root, 'lead_form_error', {
            form_id: 'property_management_print_quote',
            error_type: 'client_validation'
          });
        },
        true
      );

      form.addEventListener('submit', () => {
        try {
          window.sessionStorage.setItem(leadPendingKey, String(Date.now()));
          window.sessionStorage.removeItem(leadSentKey);
        } catch (error) {
          return;
        }
      });
    }

    const successMessage = root.querySelector('[data-ga4-lead-success]');
    const errorMessage = root.querySelector('[data-ga4-form-error]');
    if (successMessage || errorMessage) {
      let pendingSubmission = null;
      let leadAlreadySent = false;
      try {
        const pendingAt = Number(window.sessionStorage.getItem(leadPendingKey));
        pendingSubmission = Number.isFinite(pendingAt) && pendingAt > 0 && Date.now() - pendingAt <= leadPendingTtl;
        window.sessionStorage.removeItem(leadPendingKey);
        leadAlreadySent = window.sessionStorage.getItem(leadSentKey) === 'true';
      } catch (error) {
        pendingSubmission = null;
      }

      const resultUrl = new URL(window.location.href);
      const hasReturnMarker = resultUrl.searchParams.get('property_management_posted') === 'true';
      const verifiedOutcome = pendingSubmission === true || (pendingSubmission === null && hasReturnMarker);

      if (successMessage && verifiedOutcome && !leadAlreadySent) {
        sendPropertyManagementEvent(root, 'generate_lead', {
          form_id: 'property_management_print_quote',
          lead_source: 'property_management_landing_page'
        });
        try {
          window.sessionStorage.setItem(leadSentKey, 'true');
        } catch (error) {
          leadAlreadySent = true;
        }
      }
      if (errorMessage && verifiedOutcome) {
        sendPropertyManagementEvent(root, 'lead_form_error', {
          form_id: 'property_management_print_quote',
          error_type: 'server_validation'
        });
      }
      if (successMessage) successMessage.focus();

      if (hasReturnMarker) {
        resultUrl.searchParams.delete('property_management_posted');
        window.history.replaceState(
          window.history.state,
          '',
          `${resultUrl.pathname}${resultUrl.search}${resultUrl.hash}`
        );
      }
    }

    const scrollMilestones = [25, 50, 75];
    const sentMilestones = new Set();
    let scrollFramePending = false;
    const measureScroll = () => {
      scrollFramePending = false;
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollableHeight <= 0) return;
      const percentScrolled = Math.round((window.scrollY / scrollableHeight) * 100);
      scrollMilestones.forEach((milestone) => {
        if (percentScrolled >= milestone && !sentMilestones.has(milestone)) {
          sentMilestones.add(milestone);
          sendPropertyManagementEvent(root, 'scroll_depth', {
            percent_scrolled: milestone
          });
        }
      });
    };
    window.addEventListener(
      'scroll',
      () => {
        if (scrollFramePending) return;
        scrollFramePending = true;
        window.requestAnimationFrame(measureScroll);
      },
      { passive: true }
    );
    measureScroll();
  };

  const initPropertyManagement = (root) => {
    document.documentElement.classList.add('pm-motion-ready');
    const reveals = root.querySelectorAll('.pm-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach((element) => element.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      reveals.forEach((element) => observer.observe(element));
    }
    initPropertyManagementAnalytics(root);
  };

  document.querySelectorAll('.pm-page').forEach(initPropertyManagement);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.pm-page');
    if (root) initPropertyManagement(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-graphics-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => scope.querySelectorAll('[data-vg-root]').forEach((root) => {
      if (root.dataset.vgReady === 'true') return;
      root.dataset.vgReady = 'true';

      const dialog = root.querySelector('[data-vg-quote-dialog]');
      const openers = root.querySelectorAll('[data-vg-quote-open]');
      const closers = root.querySelectorAll('[data-vg-quote-close]');
      const form = root.querySelector('.vg-seo__form');
      const message = root.querySelector('[data-vg-form-message]');
      const success = root.querySelector('[data-vg-form-success]');
      const leadPendingKey = `vehicle_graphics_lead_pending_at:${window.location.pathname}:${root.dataset.pageKind || 'vehicle_graphics'}`;
      const leadSentKey = `vehicle_graphics_generate_lead_sent:${window.location.pathname}:${root.dataset.pageKind || 'vehicle_graphics'}`;
      const leadPendingTtl = 30 * 60 * 1000;
      let activeOpener = null;

      if (!dialog) return;

      const track = (eventName) => {
        const detail = {
          event: eventName,
          rfq_source: 'vehicle_landing_page',
          service_type: root.dataset.pageKind || 'vehicle_graphics',
          page_handle: window.location.pathname,
          page_type: root.dataset.pageKind || 'vehicle_graphics'
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);
        if (typeof window.gtag === 'function') window.gtag('event', eventName, detail);
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(eventName, detail);
        }
        root.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
      };

      const openDialog = (opener, shouldTrack = true) => {
        activeOpener = opener || document.activeElement;
        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('vg-seo-dialog-open');
        if (shouldTrack) track('rfq_form_open');
        window.requestAnimationFrame(() => {
          const focusTarget = message || dialog.querySelector('input, select, textarea, button');
          if (focusTarget) focusTarget.focus();
        });
      };

      const closeDialog = () => {
        if (!dialog.open) return;
        if (typeof dialog.close === 'function') dialog.close();
        else {
          dialog.removeAttribute('open');
          document.documentElement.classList.remove('vg-seo-dialog-open');
          if (activeOpener && typeof activeOpener.focus === 'function') activeOpener.focus();
        }
      };

      openers.forEach((opener) => opener.addEventListener('click', () => openDialog(opener)));
      closers.forEach((closer) => closer.addEventListener('click', closeDialog));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('vg-seo-dialog-open');
        if (activeOpener && typeof activeOpener.focus === 'function') activeOpener.focus();
      });

      if (form) {
        const returnToInput = form.querySelector('input[name="return_to"]');
        const currentPageUrl = new URL(window.location.href);
        const quoteAnchor = root.querySelector('.vg-seo__quote-band');
        const isShopifyPreview =
          currentPageUrl.hostname.endsWith('.shopifypreview.com') &&
          currentPageUrl.searchParams.has('preview_key');
        const isThemePreview =
          isShopifyPreview ||
          currentPageUrl.searchParams.has('preview_theme_id') ||
          currentPageUrl.searchParams.has('view') ||
          currentPageUrl.hostname === '127.0.0.1' ||
          currentPageUrl.hostname === 'localhost';

        if (returnToInput && isThemePreview) {
          currentPageUrl.searchParams.set('contact_posted', 'true');
          returnToInput.value = `${currentPageUrl.pathname}${currentPageUrl.search}${
            quoteAnchor && quoteAnchor.id ? `#${quoteAnchor.id}` : ''
          }`;
        }

        form.addEventListener('submit', () => {
          track('rfq_form_submit');
          try {
            window.sessionStorage.setItem(leadPendingKey, String(Date.now()));
            window.sessionStorage.removeItem(leadSentKey);
          } catch (error) {
            return;
          }
        });
      }

      if (message || new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
        openDialog(null, false);
      }

      if (success) {
        let pendingSubmission = null;
        let leadAlreadySent = false;
        try {
          const pendingAt = Number(window.sessionStorage.getItem(leadPendingKey));
          pendingSubmission = Number.isFinite(pendingAt) && pendingAt > 0 && Date.now() - pendingAt <= leadPendingTtl;
          window.sessionStorage.removeItem(leadPendingKey);
          leadAlreadySent = window.sessionStorage.getItem(leadSentKey) === 'true';
        } catch (error) {
          pendingSubmission = null;
        }

        const resultUrl = new URL(window.location.href);
        const hasReturnMarker = resultUrl.searchParams.get('contact_posted') === 'true';
        const verifiedOutcome = pendingSubmission === true || (pendingSubmission === null && hasReturnMarker);

        if (verifiedOutcome && !leadAlreadySent) {
          track('generate_lead');
          try {
            window.sessionStorage.setItem(leadSentKey, 'true');
          } catch (error) {
            leadAlreadySent = true;
          }
        }

        if (hasReturnMarker) {
          resultUrl.searchParams.delete('contact_posted');
          window.history.replaceState({}, '', `${resultUrl.pathname}${resultUrl.search}${resultUrl.hash}`);
        }
      }
    });

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
